/* ============================================================
   ARCTA · Sticky Kontakt-Button
   Gehoert zu sections/sticky-contact-button.liquid.
   Die Einstellungen kommen als JSON aus #ScbConfig, damit diese Datei
   statisch bleibt und gecacht werden kann.
   ============================================================ */

(function () {
  var btn = document.getElementById('ScbButton');
  if (!btn) return;

  var cfgEl = document.getElementById('ScbConfig');
  if (!cfgEl) return;
  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {
    console.error('[sticky-contact-button] Konfiguration nicht lesbar', e);
    return;
  }

  /* ---------- Öffnungszeiten ---------- */

  var hoursValid = true;

  function parseWindows(str) {
    var out = [];
    if (!str || !String(str).trim()) return out;
    String(str).split(',').forEach(function (part) {
      var m = /^\s*(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})\s*$/.exec(part);
      if (!m) {
        hoursValid = false;
        return;
      }
      var from = parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
      var to = parseInt(m[3], 10) * 60 + parseInt(m[4], 10);
      // Fenster der Laenge null heisst geschlossen, nicht "rund um die Uhr".
      // Ohne diese Zeile wuerde 00:00-00:00 als Fenster ueber Mitternacht gelten.
      if (from === to) return;
      out.push([from, to]);
    });
    return out;
  }

  var WINDOWS = {
    weekday: parseWindows(CFG.hours.weekday),
    sat: parseWindows(CFG.hours.sat),
    sun: parseWindows(CFG.hours.sun)
  };

  if (!hoursValid && CFG.hoursEnabled) {
    // Fail-open: bei einem Tippfehler in den Öffnungszeiten bleibt der
    // Telefon-Button erreichbar, statt still zu verschwinden.
    console.warn('[sticky-phone-button] Öffnungszeiten nicht lesbar – erwartet HH:MM-HH:MM. Zeitsteuerung ist deaktiviert.');
  }

  var DAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function berlinNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Berlin',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).formatToParts(new Date());
      var v = {};
      parts.forEach(function (p) { v[p.type] = p.value; });
      var day = DAYS[v.weekday];
      var hour = parseInt(v.hour, 10) % 24;
      if (day === undefined || isNaN(hour)) return null;
      return { day: day, minutes: hour * 60 + parseInt(v.minute, 10) };
    } catch (e) {
      return null;
    }
  }

  // Ende des laufenden Fensters in Minuten seit Mitternacht.
  // null = keine Zeitsteuerung (rund um die Uhr erreichbar), -1 = gerade geschlossen.
  function windowEnd() {
    if (!CFG.hoursEnabled || !hoursValid) return null;
    var now = berlinNow();
    if (!now) return null; // kein Intl/Zeitzone verfügbar → Telefon zeigen
    var list = now.day === 0 ? WINDOWS.sun : (now.day === 6 ? WINDOWS.sat : WINDOWS.weekday);
    for (var i = 0; i < list.length; i++) {
      var from = list[i][0];
      var to = list[i][1];
      if (to > from ? (now.minutes >= from && now.minutes < to)
                    : (now.minutes >= from || now.minutes < to)) return to;
    }
    return -1;
  }

  function isOpen() {
    return windowEnd() !== -1;
  }

  /* ---------- Messung ---------- */

  // Shopify-Kundenevent (für Custom Pixel) und Clarity-Event. Darf nie werfen.
  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(name, data || {});
      }
      if (typeof window.clarity === 'function') window.clarity('event', name);
    } catch (e) { /* Messung ist nie wichtiger als der Button */ }
  }

  /* ---------- Button-Zustand ---------- */

  var currentMode = null;

  function applyMode() {
    var mode = isOpen() ? 'phone' : CFG.closedMode;
    if (mode === currentMode) return;
    currentMode = mode;

    if (mode === 'hide') {
      btn.hidden = true;
      return;
    }
    btn.hidden = false;

    var label = mode === 'phone' ? CFG.openLabel : CFG.closedLabel;
    btn.setAttribute('data-mode', mode);
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);

    if (mode === 'phone') {
      btn.setAttribute('href', CFG.telHref);
      btn.removeAttribute('target');
      btn.removeAttribute('rel');
    } else if (mode === 'whatsapp') {
      btn.setAttribute('href', CFG.waHref);
      btn.setAttribute('target', '_blank');
      btn.setAttribute('rel', 'noopener');
    } else {
      btn.setAttribute('href', '#');
      btn.removeAttribute('target');
      btn.removeAttribute('rel');
    }
  }

  applyMode();
  setInterval(applyMode, 60000); // offene Tabs schalten zur vollen Minute um

  btn.addEventListener('click', function () {
    track('scb_button_click', { mode: currentMode, page: window.location.pathname });
  });

  /* ---------- Wackeln ---------- */

  var shake = function () {};

  if (CFG.shake && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var duration = 600;
    var pause = Math.max(1, CFG.shakeInterval) * 1000;

    shake = function () {
      if (btn.hidden || btn.classList.contains('is-behind-card') || !btn.animate) return;
      btn.animate([
        { transform: 'rotate(0deg)' },
        { transform: 'rotate(-12deg)' },
        { transform: 'rotate(12deg)' },
        { transform: 'rotate(-12deg)' },
        { transform: 'rotate(12deg)' },
        { transform: 'rotate(-8deg)' },
        { transform: 'rotate(8deg)' },
        { transform: 'rotate(-4deg)' },
        { transform: 'rotate(0deg)' }
      ], { duration: duration, easing: 'ease-in-out' });
    };

    setTimeout(shake, 1500);
    setInterval(shake, pause + duration);
  }

  /* ---------- Persönliche Karte ---------- */

  var card = document.getElementById('ScbCard');
  if (card) initCard();

  function initCard() {
    var SEEN_KEY = 'scb_card_seen';       // sessionStorage: einmal pro Sitzung
    var SNOOZE_KEY = 'scb_card_snooze';   // localStorage: Ruhe nach Wegklicken
    var design = card.getAttribute('data-design') === '1' || !!(window.Shopify && Shopify.designMode);
    var delay = design ? 1000 : Math.max(0, Number(card.getAttribute('data-delay')) || 0) * 1000;
    var snoozeDays = Math.max(0, Number(card.getAttribute('data-snooze')) || 0);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var shown = false;
    var timer = null;

    // Speicher kann werfen (privater Modus, blockierte Site-Daten). Im Zweifel
    // erscheint die Karte lieber einmal zu oft als gar nicht.
    function read(store, key) {
      try { return window[store].getItem(key); } catch (e) { return null; }
    }
    function write(store, key, value) {
      try { window[store].setItem(key, value); } catch (e) { /* egal */ }
    }

    if (!design) {
      if (read('sessionStorage', SEEN_KEY) === '1') return;
      var until = parseInt(read('localStorage', SNOOZE_KEY), 10);
      if (until && until > Date.now()) return;
    }

    // Nicht über offene Drawer, Modals, das VIP-Overlay oder das VIP-Formular legen.
    function blocked() {
      var html = document.documentElement;
      var body = document.body;
      return html.classList.contains('js-drawer-open') ||
        html.classList.contains('vipo-locked') ||
        html.classList.contains('avip-form-in-view') ||
        body.classList.contains('js-drawer-open') ||
        body.classList.contains('trust-modal-open') ||
        !!document.querySelector('.scb-modal.is-open');
    }

    function untilLabel() {
      var end = windowEnd();
      if (end === null || end < 0) return '';
      var h = Math.floor(end / 60) % 24;
      var m = end % 60;
      return h + (m ? ':' + (m < 10 ? '0' : '') + m : '') + ' Uhr';
    }

    function open() {
      timer = null;
      if (shown) return;
      if (!design && currentMode !== 'phone') return; // nur zu Öffnungszeiten
      if (blocked()) {
        timer = setTimeout(open, 3000);
        return;
      }
      shown = true;
      if (!design) write('sessionStorage', SEEN_KEY, '1');

      // „bis 19 Uhr“ bleibt zusammen, umbrechen darf nur davor.
      var label = untilLabel();
      card.querySelectorAll('[data-scb-until]').forEach(function (el) {
        el.textContent = '';
        if (!label) return;
        var keep = document.createElement('span');
        keep.className = 'scb-card__until';
        keep.textContent = el.getAttribute('data-word') + label;
        el.appendChild(document.createTextNode(el.getAttribute('data-prefix')));
        el.appendChild(keep);
      });

      card.hidden = false;
      btn.classList.add('is-behind-card');
      track('scb_card_shown', { page: window.location.pathname });
    }

    // Karte schrumpft in die Ecke, dann springt der Button auf und wackelt.
    function close(reason) {
      if (timer) clearTimeout(timer);
      timer = null;
      if (!shown || card.hidden || card.classList.contains('is-leaving')) return;

      if (reason === 'dismiss' && snoozeDays > 0 && !design) {
        write('localStorage', SNOOZE_KEY, String(Date.now() + snoozeDays * 86400000));
      }
      if (reason !== 'hours') track('scb_card_' + reason, { page: window.location.pathname });

      var hadFocus = card.contains(document.activeElement);
      var finish = function () {
        card.hidden = true;
        card.classList.remove('is-leaving');
        btn.classList.remove('is-behind-card');
        if (btn.hidden) return;
        if (hadFocus) btn.focus({ preventScroll: true });
        if (!reduced && btn.animate) {
          btn.animate([
            { transform: 'scale(0.3)', opacity: 0 },
            { transform: 'scale(1.12)', opacity: 1, offset: 0.65 },
            { transform: 'scale(1)', opacity: 1 }
          ], { duration: 420, easing: 'ease-out' });
          setTimeout(shake, 1100);
        }
      };

      if (reduced) {
        finish();
        return;
      }
      card.classList.add('is-leaving');
      setTimeout(finish, 340);
    }

    card.querySelector('[data-scb-card-close]').addEventListener('click', function () {
      close('dismiss');
    });

    card.querySelectorAll('[data-scb-card-call]').forEach(function (link) {
      link.addEventListener('click', function () {
        setTimeout(function () { close('call'); }, 150);
      });
    });

    var copyBtn = card.querySelector('[data-scb-card-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var number = copyBtn.getAttribute('data-number');
        var done = function () {
          copyBtn.classList.add('is-copied');
          copyBtn.setAttribute('aria-label', 'Nummer kopiert');
          setTimeout(function () {
            copyBtn.classList.remove('is-copied');
            copyBtn.setAttribute('aria-label', 'Nummer kopieren');
          }, 1800);
          track('scb_card_copy', { page: window.location.pathname });
        };
        // Älterer Weg, falls die Clipboard-API fehlt oder abgelehnt wird
        // (eingebettete Browser, fehlende Berechtigung).
        var legacy = function () {
          var tmp = document.createElement('textarea');
          tmp.value = number;
          tmp.setAttribute('readonly', '');
          tmp.style.position = 'fixed';
          tmp.style.opacity = '0';
          document.body.appendChild(tmp);
          tmp.select();
          try { if (document.execCommand('copy')) done(); } catch (e) { /* nichts zu tun */ }
          document.body.removeChild(tmp);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(number).then(done, legacy);
        } else {
          legacy();
        }
      });
    }

    // Escape nur, wenn der Fokus in der Karte steht – sonst würde jedes
    // Schließen eines Drawers die Karte gleich mit wegschicken.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && card.contains(document.activeElement)) close('dismiss');
    });

    // Wer den Chat öffnet, braucht die Telefon-Karte nicht mehr.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#cx-armin-chat-widget-v2')) close('chat');
    }, true);

    // Laufen die Öffnungszeiten ab, während die Karte offen ist, geht sie still zu.
    setInterval(function () {
      if (!design && currentMode !== 'phone') close('hours');
    }, 60000);

    timer = setTimeout(open, delay);
  }

  /* ---------- Rückruf-Popup ---------- */

  var modal = document.getElementById('ScbModal');
  if (!modal) return;

  var form = document.getElementById('ScbForm');
  var formWrap = document.getElementById('ScbFormWrap');
  var success = document.getElementById('ScbSuccess');
  var throttled = document.getElementById('ScbThrottled');
  var errorEl = document.getElementById('ScbError');
  var submitBtn = document.getElementById('ScbSubmit');
  var submitLabel = submitBtn.textContent;
  var lastFocus = null;

  function openModal(e) {
    if (currentMode !== 'callback') return;
    e.preventDefault();
    lastFocus = document.activeElement;
    // Sicherheitsnetz: Motion faerbt die Seite ueber body.unloading aus und
    // raeumt die Klasse nur beim Navigieren wieder weg. Passiert das trotz
    // js-no-transition, bliebe die Seite weiss stehen.
    document.body.classList.remove('unloading');
    // Zustand bei jedem Oeffnen zuruecksetzen, sonst stapeln sich Erfolgs-
    // und Sperrfrist-Hinweis uebereinander und das Formular zeigt noch die
    // alten Eingaben mit deaktiviertem Button.
    var gesperrt = throttleRest() > 0;
    success.hidden = true;
    throttled.hidden = !gesperrt;
    formWrap.hidden = gesperrt;
    errorEl.hidden = true;
    if (!gesperrt) {
      form.reset();
      submitBtn.disabled = false;
      submitBtn.textContent = submitLabel;
    }

    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var first = formWrap.hidden ? modal.querySelector('[data-scb-close]')
                               : modal.querySelector('#ScbName');
    if (first) first.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  btn.addEventListener('click', openModal);

  modal.querySelectorAll('[data-scb-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  // Deutsche Eingaben nach E.164 normalisieren – Klaviyo weist alles
  // andere als Telefonnummer ab und würde den ganzen Request verwerfen.
  function toE164(raw) {
    var d = String(raw).replace(/[^\d+]/g, '');
    if (d.indexOf('00') === 0) d = '+' + d.slice(2);
    else if (d.indexOf('0') === 0) d = '+49' + d.slice(1);
    else if (d.indexOf('+') !== 0) d = '+49' + d;
    return /^\+\d{8,15}$/.test(d) ? d : null;
  }

  // Sperrfrist gegen Mehrfach-Absenden. localStorage kann werfen (privater
  // Modus, blockierte Site-Daten), deshalb ist jeder Zugriff gekapselt und
  // faellt im Zweifel auf "nicht gesperrt" zurueck - lieber ein Event zu viel
  // als ein verlorener Lead.
  var THROTTLE_KEY = 'scb_last_callback';

  function throttleRest() {
    var minutes = Number(CFG.throttleMinutes) || 0;
    if (minutes <= 0) return 0;
    try {
      var last = parseInt(window.localStorage.getItem(THROTTLE_KEY), 10);
      if (!last) return 0;
      var rest = last + minutes * 60000 - Date.now();
      return rest > 0 ? rest : 0;
    } catch (e) {
      return 0;
    }
  }

  function markSent() {
    try {
      window.localStorage.setItem(THROTTLE_KEY, String(Date.now()));
    } catch (e) {
      /* ohne Speicher greift die Sperrfrist nicht - kein Grund abzubrechen */
    }
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorEl.hidden = true;

    if (form.elements.website.value) { // Honeypot
      markSent();
      formWrap.hidden = true;
      success.hidden = false;
      return;
    }

    var name = form.elements.name.value.trim();
    var phoneRaw = form.elements.phone.value.trim();
    if (!name || !phoneRaw) {
      showError('Bitte Name und Telefonnummer angeben.');
      return;
    }
    if (form.elements.consent && !form.elements.consent.checked) {
      showError('Bitte bestätige die Einwilligung.');
      return;
    }
    if (!CFG.klaviyoId) {
      showError('Der Rückruf-Service ist gerade nicht verfügbar. Bitte ruf uns direkt an.');
      return;
    }

    var e164 = toE164(phoneRaw);
    var profile = e164
      ? { phone_number: e164, first_name: name }
      : { anonymous_id: 'scb-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8), first_name: name };

    var payload = {
      data: {
        type: 'event',
        attributes: {
          properties: {
            'Telefonnummer': phoneRaw,
            'Telefonnummer normalisiert': e164 || '',
            'Wunschzeit': form.elements.time ? form.elements.time.value : '',
            'Nachricht': form.elements.message.value.trim(),
            'Seite': window.location.pathname,
            'Quelle': 'Sticky Kontakt-Button'
          },
          metric: { data: { type: 'metric', attributes: { name: CFG.klaviyoMetric } } },
          profile: { data: { type: 'profile', attributes: profile } }
        }
      }
    };

    submitBtn.disabled = true;
    submitBtn.textContent = 'Wird gesendet …';

    fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(CFG.klaviyoId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Klaviyo ' + res.status);
        markSent();
        formWrap.hidden = true;
        success.hidden = false;
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('scb_callback_requested', { source: 'sticky_contact_button' });
        }
      })
      .catch(function (err) {
        console.error('[sticky-phone-button]', err);
        showError('Das hat leider nicht geklappt. Bitte versuch es erneut oder ruf uns direkt an.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Rückruf anfordern';
      });
  });
})();
